import {TextProps, Text} from "@mantine/core";
import {useTranslation} from "react-i18next";

export type YesNoTextProps = Omit<TextProps, 'children'> & {
  value?: boolean;
}

export const YesNoText = (props: YesNoTextProps) => {
  const {value, ...rest} = props;

  const { t } = useTranslation(["common"]);

  return (
    <Text {...rest}>
      {value ? t("common.yes", "Yes") : t("common.no", "No")}
    </Text>
  );
}

